import { Cancel01Icon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC } from "react";
import { getFilterDisplayName } from "shared/app/LeadsTableView/utils/getFilterDisplayName";

interface Props {
  filter: string;
  onRemove: () => void;
  formatFilter?: (filter: string) => string;
}

export const FilterBadge: FC<Props> = ({
  filter,
  onRemove,
  formatFilter = getFilterDisplayName
}) => {
  return (
    <div className="py-2 px-4 items-center border border-alpha-40 bg-primary-20 text-primary-600 text-xs font-medium rounded-lg flex gap-1.5 justify-between">
      <p className="max-w-[100px] truncate" title={formatFilter(filter)}>
        {formatFilter(filter)}
      </p>
      <button onClick={onRemove}>
        <HugeiconsIcon
          icon={Cancel01Icon}
          size="18"
          className="stroke-primary-600"
        />
      </button>
    </div>
  );
};
